export default __webpack_public_path__ + "static/media/gradiant-large.a1086a58.jpg";